import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import '../../main-css/login-css/LoginPopUp.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_PROD_URL;

const LoginPopUp = ({onClose}) => {
    const [userOrEmail, setUserOrEmail] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isRegisterMode, setIsRegisterMode] = useState(false);
    const [isForgotPasswordMode, setIsForgotPasswordMode] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    
    useEffect(() =>{
        const checkLogin = async() =>{
            let response = await fetch(`${BACKEND_URL}/valid/profile`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
    
            if (response.status === 401) {  // User is not authenticated
                const refreshResponse = await fetch(`${BACKEND_URL}/valid/refresh-token`, {
                    method: 'POST',
                    credentials: 'include'
                });

                if (!refreshResponse.ok) return; // If refresh fails, exit early

                response = await fetch(`${BACKEND_URL}/valid/profile`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' }
                });
            }
            
            if(response.ok) navigate(`/valid/profile`);
        }
        checkLogin();
    },[]);

    const detectSQLInjection = (input) => {
        const sqlPatterns = [/--/, /;/, /\/\*/, /\*\//, /UNION/i, /DROP/i];
        return sqlPatterns.some((pattern) => pattern.test(input));
      };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isForgotPasswordMode)return handleForgotPassword(e);

        const userData = isRegisterMode ? { username: userOrEmail, email, password }: {userOrEmail, password};

        if(detectSQLInjection(userData)) setErrorMessage("Malicious Content!");;
        if (loading) return;
        setLoading(true);

        try{
            const endpoint = isRegisterMode ? `${BACKEND_URL}/valid/register`: `${BACKEND_URL}/valid/login`;
            const response = await fetch(endpoint, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(userData),
                });
            if(!response.ok){
                const data = await response.json();
                throw new Error(data.error || 'Failed to register/login user');
            }
            if(onClose)onClose();
            navigate(`/valid/profile`);

        }catch(err){
            setErrorMessage(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        if (loading) return;
        setLoading(true);
        try {
     
          const response = await fetch(`${BACKEND_URL}/valid/forgot-password`, {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
          });
             
          const data = await response.json();
          
          if (!response.ok) {
            throw new Error(data.error || 'Failed to send reset email');
          }
          
          setMessage('Check your email for a reset link.');
        } catch (error) {
          console.error('Password reset error:', error);
          setMessage(`Error: ${error.message || 'Unable to send reset link.'}`);
        } finally {
            setLoading(false);
        }
      };

    return (
        <div className="modal-overlay" onMouseDown={onClose}>
            <div className="modal-content" onMouseDown={(e) => e.stopPropagation()}>
                <span className="close-btn" onClick={onClose}>&times;</span>
                
                {isForgotPasswordMode ? (
                    <>
                        <h2>Forgot Password</h2>
                        {message && <p className="success-text">{message}</p>}
                        <form onSubmit={handleForgotPassword}>
                            <input
                                type="email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <button type="submit" className="submit-btn" disabled={loading}>
                                {loading ? 'Sending...' : 'Send Reset'}
                            </button>
                        </form>
                        <span className="toggle-mode-text" onClick={() => setIsForgotPasswordMode(false)}>
                            Back to Login
                        </span>
                    </>
                ) : (
                    <>
                        <h2>{isRegisterMode ? 'Register' : 'Login'}</h2>
                        {errorMessage && <p className="error-text">{errorMessage}</p>}
                        <form onSubmit={handleSubmit}>
                            <input
                                type="text"
                                placeholder={isRegisterMode ? 'Username' : 'Username/Email'}
                                value={userOrEmail}
                                onChange={(e) => setUserOrEmail(e.target.value)}
                                required
                            />
                            {isRegisterMode && (
                                <input
                                    type="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            )}
                            <input
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            {isRegisterMode && 
                            <p className='password-text'>Must be 6 characters long, contain at least one uppercase, and at least one special character </p>}
                            {!isRegisterMode && (
                                <span className="toggle-mode-text" onClick={() => setIsForgotPasswordMode(true)}>
                                    Forgot Password?
                                </span>
                            )}
                            <span className="toggle-mode-text" onClick={() => setIsRegisterMode(!isRegisterMode)}>
                                {isRegisterMode ? 'Login Here!' : 'Register Here!'}
                            </span>
                            <button type="submit" className="submit-btn" disabled={loading}>
                                {loading ? 'Processing...' : isRegisterMode ? 'Register' : 'Login'}
                            </button>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
};

export default LoginPopUp;